/* oxlint-disable no-console */
import * as Sentry from '@sentry/react';
import Config from 'src/common/Config';

export class Logger {
  static error(message: string, error: unknown, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.error(`${message}. ${JSON.stringify(data)}`, error);
    }

    // Sentry will omit all keys that have a null or undefined value, so we're converting it to the string equivalents
    const sanitizedData = data
      ? Object.entries(data).reduce(
          (acc, [key, value]) => {
            acc[key] = value === null ? '-> null' : value === undefined ? '-> undefined' : value;
            return acc;
          },
          {} as { [key: string]: unknown },
        )
      : {};
    Sentry.captureException(error, { extra: { message, ...sanitizedData } });
  }

  static warn(message: string, data?: { [key: string]: unknown }): void {
    Logger.error(`WARNING: ${message}`, new Error(`WARNING: ${message}`), data);
  }

  static info(message: string, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.info(`${message}. ${JSON.stringify(data)}`);
    }
    Sentry.addBreadcrumb({
      message,
      data,
      level: 'info',
    });
  }
}
